import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { toggleLoading } from "../../../Redux/reducers/loadingSlice";
import { baseUrl } from "../../../shared/baseUrl";
import { checkAuth } from "../../../Utils/CheckAuthentication";
import { TOKEN_KEY } from "../../../Utils/Constants";
import { createNotification } from "../../Common/CreateNotification";

const ResetPassword = () => {

    const { email, token } = useParams()

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const dispatch = useDispatch();

    const resetPassword = (e) => {
        e.preventDefault();
        dispatch(toggleLoading(true));
        var formData = new FormData();
        formData.append('token', token);
        formData.append('password', password);
        formData.append('password_confirmation', confirmPassword);
        fetch(baseUrl + 'change-password', {
            method: 'POST',
            body: formData
        })
            .then(res => checkAuth(res))
            .then(res => {
                if (res.success) {
                    createNotification('success', res.message);
                    localStorage.removeItem(TOKEN_KEY);
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 2000)


                }
                else {
                    createNotification('error', res.message);
                    dispatch(toggleLoading(false));
                }
            })
            .catch(err => {
                createNotification('error', "Error sending password reset link.");
                dispatch(toggleLoading(false));
            });
    }
    return (
        <div style={{ height: "90vh", overflow: "hidden" }} className='d-flex flex-wrap w-100 justify-content-center align-items-center'>
            <div className='text-center small'>
                <img alt="logo" style={{ objectFit: "contain", height: "20vh", width: "20vh" }} src="/assets/images/logo.png" />
                <h3>Reset Password</h3>
                <div className="my-3 mx-5 py-3 px-5 border rounded text-start shadow">
                    <p className="small">Email: {email}</p>
                    <form onSubmit={resetPassword} className='g-3' autoComplete="off">
                        <div className="mb-3">
                            <label className="form-label">New Password</label>
                            <input required type="password" className="form-control" placeholder='Enter new password' autoComplete='false' value={password} onChange={(e) => { setPassword(e.target.value); }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Password</label>
                            <input required type="password" className="form-control" placeholder='Re-type your new password' autoComplete='false' value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value); }} />
                        </div>
                        <div className='d-flex flex wrap justify-content-between'>
                            <button disabled={password !== "" && confirmPassword !== "" && password === confirmPassword ? false : true} type="submit" className="btn btn-primary">Change</button>
                        </div>
                    </form>
                </div>
                <p className='small'>Go to <Link to="/">home</Link></p>
            </div>
        </div>
    );
}

export default ResetPassword;